// workflow lib
import generateTriggerObjects from './generateTriggerObjects.lib.workflow';

const isPeriodRequired = ({trigger}) =>
  generateTriggerObjects({trigger}).some(({type}) => type !== 'boolean');

export default isPeriodRequired;
